// All countries from the global coverage map, each with the same keyword system as the main markets
import { REGIONS } from '../mock/locations';
import { slugify } from './coreKeywords';

const MAIN_MARKETS = { 'united-states': '/usa', canada: '/canada', 'united-kingdom': '/uk', australia: '/australia' };

const primaryKw = (n) => [
  `land survey CAD drafting services provider ${n}`,
  `outsourced survey CAD drafting ${n}`,
  `land survey drafting services ${n}`,
  `survey CAD drafting company ${n}`,
  `CAD drafting for land surveyors ${n}`,
  `outsourced CAD drafting services ${n}`,
  `topographic survey drafting ${n}`,
  `Civil 3D survey drafting ${n}`,
  `GIS mapping services ${n}`
];

const serviceKw = (n) => [
  `boundary survey drafting ${n}`,
  `cadastral survey drafting ${n}`,
  `subdivision plan drafting ${n}`,
  `as-built survey drafting ${n}`,
  `existing conditions CAD drawings ${n}`,
  `point cloud to CAD ${n}`,
  `LiDAR to CAD conversion ${n}`,
  `survey data conversion ${n}`,
  `PDF survey to DWG ${n}`,
  `contour mapping and CAD drafting ${n}`,
  `AutoCAD drafting services for surveyors ${n}`,
  `survey plan drafting services ${n}`
];

export const GLOBAL_CONTINENTS = REGIONS.map(r => ({
  id: r.id,
  name: r.id === 'asia' ? 'Asia & Middle East' : r.name,
  countries: r.countries.map(c => {
    const slug = slugify(c.name);
    return {
      slug, code: c.code, name: c.name, hub: !!c.hub,
      cities: c.cities || [],
      mainMarket: MAIN_MARKETS[slug] || null,
      primaryKeywords: primaryKw(c.name),
      serviceKeywords: serviceKw(c.name)
    };
  })
}));

export const ALL_COUNTRIES = GLOBAL_CONTINENTS.flatMap(c => c.countries);
export const getGlobalCountry = (slug) => ALL_COUNTRIES.find(c => c.slug === slug);
